import Hero from "@/sections/Hero";
import VoiceNav from "@/sections/VoiceNav";
import About from "@/sections/About";
import Cases from "@/sections/Cases";
import Evidence from "@/sections/Evidence";
import Tools from "@/sections/Tools";
import Languages from "@/sections/Languages";
import Credentials from "@/sections/Credentials";
import Terms from "@/sections/Terms";
import Contact from "@/sections/Contact";
import Footer from "@/components/Footer";
import { Divider } from "@/components/primitives";
import CaseModal from "@/components/CaseModal";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <VoiceNav />
      <Divider />
      <About />
      <Divider />
      <Cases />
      <Divider />
      <Evidence />
      <Divider />
      <Tools />
      <Divider />
      <Languages />
      <Divider />
      <Credentials />
      <Divider />
      <Terms />
      <Divider />
      <Contact />
      <Divider />
      <Footer />
      <CaseModal />
    </main>
  );
}
